export const DashboardErrorPage = () => {
  return <h1 style={{ textAlign: "center" }}>404 Not Found</h1>;
};
